export default __webpack_public_path__ + "images/W1.27b6cba.png";